import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { DEFAULT_API } from "../../utils/variables";
import { ServiceIcon } from "../../assets/image/ServiceIcon";
import { ConfirmIcon } from "../../assets/image/ConfirmIcon";
import { SocialFacebook } from "../../components/common/SocialFacebook";
import { StarIcon } from "../../assets/image/StarIcon";
import { WhiteStarIcon } from "../../assets/image/WhiteStarIcon";
import { FavoriteProfile } from "../../components/common/FavoriteProfile";
import { PhoneIcon } from "../../assets/image/PhoneIcon";

export const SearchCandidate = ({ data, index, profile, handleElementContent }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const navigate = useNavigate();
    const parseIfJson = (value) => {
        try {
            return typeof value === "string" ? JSON.parse(value) : value;
        } catch {
            return value;
        }
    };

    const getTranslatedInterest = (interest) => {
        if (typeof interest === "string") return t(interest);
        if (interest?.occasionally && interest.occasionally !== "") return t(interest.occasionally);
        if (interest?.fulltime && interest.fulltime !== "") return t(interest.fulltime);
        if (interest?.parttime && interest.parttime !== "") return t(interest.parttime);
        return t(interest.occasionally);
    };

  return (
    <div className="mobile_looking_for_candidate_box">
      <div className="head_part">
        <h3
          onClick={(e) => {
            navigate("/profile-provider/" + data.id);
          }}
        >
          {data.profile_headline != null ? data.profile_headline : ""}
        </h3>
        {data.plateformsocialmedia == "Yes" ? (
          <SocialFacebook
            link={window.location.origin + "/profile-provider/" + data.id}
          />
        ) : (
          ""
        )}
      </div>
      <div className="post_general">
        <h6
          onClick={(e) => {
            navigate("/profile-provider/" + data.id);
          }}
        >
          {data.first_name + " " + data.last_name} (
          {data.dob != undefined
            ? new Date().getFullYear() -
              parseInt(
                data.dob.substr(data.dob.lastIndexOf("\\") + 1).split("-")[0]
              )
            : ""}
          )
        </h6>
        <p>
          {data.reviewAvg >= 0 ? (
            <>
              {[...Array(data.reviewAvg)].map((star, index) => {
                index += 1;
                return <StarIcon />;
              })}
              {[...Array(5 - data.reviewAvg)].map((star, index) => {
                index += 1;
                return <WhiteStarIcon />;
              })}
            </>
          ) : (
            ""
          )}
          <span> ({data.reviewcount})</span>
        </p>
      </div>
      <div className="main_sec">
        <div className="first_sec">
          <div
            className="image_sec"
            onClick={(e) => {
              navigate("/profile-provider/" + data.id);
            }}
          >
            <img
              src={
                data.file_path != null
                  ? DEFAULT_API + "/assets/images/users/" + data.file_path
                  : "img/nany_img.png"
              }
              alt=""
            />
            <div className="heart_sec">
              {localStorage.getItem("user_type") == "parents" ? (
                <FavoriteProfile
                  id={data.id}
                  username={data.first_name}
                  heart2={data.favorNot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="nany_social">
              {data.phoneVerifiedStatus == 1 ? (
                <img
                  src={window.location.origin + "/images/nany_phone.svg"}
                  alt=""
                />
              ) : (
                <PhoneIcon />
              )}
              <img
                src={window.location.origin + "/images/nany_msg.svg"}
                alt=""
              />
              {data.facebookverify != null || data.linkdinverify != null ? (
                <img
                  src={window.location.origin + "/images/nany_cont.svg"}
                  alt=""
                />
              ) : (
                <ServiceIcon />
              )}
              {data.backgroundstatus == "Confirmed" ? (
                <img src={window.location.origin + "/images/ok.svg"} alt="" />
              ) : (
                <ConfirmIcon />
              )}
            </div>
          </div>
        </div>
        <div className="second_sec">
          <div className="post">
              {data.service_type != null ? (
                  t(Object.values(JSON.parse(data.service_type))[0]) == "Nanny" ? (
                      <img
                          src={
                              window.location.origin + "/images/nany_post.svg"
                          }
                          alt=""
                      />
                  ) : Object.keys(JSON.parse(data.service_type))[0] == "tab2" ? (
                      <img
                          src={
                              window.location.origin +
                              "/images/teacher_post.svg"
                          }
                          alt=""
                      />
                  ) : Object.keys(JSON.parse(data.service_type))[0] == "tab3" ? (
                      <img
                          src={
                              window.location.origin +
                              "/images/education_post.svg"
                          }
                          alt=""
                      />
                  ) : Object.keys(JSON.parse(data.service_type))[0] == "tab4" ? (
                      <img
                          src={
                              window.location.origin +
                              "/images/tutor_post.svg"
                          }
                          alt=""
                      />
                  ) : (
                      ""
                  )
              ) : (
                  ""
              )}
            <h5>
                {data.service_type != null
                    ? t(Object.values(JSON.parse(data.service_type))[0])
                    : ""}
            </h5>
          </div>

                <div className="post">
            <img src="img/post_pay.png" alt="" />
                    {language === 'sr' ? (
                        <h5>
                            {Object.keys(JSON.parse(data.service_type))[0] == "tab1"
                                ? data.nanyperhrrate != null
                                    ? data.nanyperhrrate
                                        .substr(
                                            data.nanyperhrrate.lastIndexOf("\\") + 1
                                        )
                                        .split("-")[0] *
                                    100 +
                                    " - " +
                                    data.nanyperhrrate
                                        .substr(
                                            data.nanyperhrrate.lastIndexOf("\\") + 1
                                        )
                                        .split("-")[1] *
                                    100
                                    : ""
                                : Object.keys(JSON.parse(data.service_type))[0] == "tab2"
                                    ? data.seterhrrate != null
                                        ? data.seterhrrate
                                            .substr(
                                                data.seterhrrate.lastIndexOf("\\") + 1
                                            )
                                            .split("-")[0] *
                                        100 +
                                        " - " +
                                        data.seterhrrate
                                            .substr(
                                                data.seterhrrate.lastIndexOf("\\") + 1
                                            )
                                            .split("-")[1] *
                                        100
                                        : ""
                                    : Object.keys(JSON.parse(data.service_type))[0] == "tab3"
                                        ? data.seperhrrate != null
                                            ? data.seperhrrate
                                                .substr(
                                                    data.seperhrrate.lastIndexOf("\\") + 1
                                                )
                                                .split("-")[0] *
                                            100 +
                                            " - " +
                                            data.seperhrrate
                                                .substr(
                                                    data.seperhrrate.lastIndexOf("\\") + 1
                                                )
                                                .split("-")[1] *
                                            100
                                            : ""
                                        : Object.keys(JSON.parse(data.service_type))[0] == "tab4"
                                            ? data.tutorperhrrate != null
                                                ? data.tutorperhrrate
                                                    .substr(
                                                        data.tutorperhrrate.lastIndexOf("\\") + 1
                                                    )
                                                    .split("-")[0] *
                                                100 +
                                                " - " +
                                                data.tutorperhrrate
                                                    .substr(
                                                        data.tutorperhrrate.lastIndexOf("\\") + 1
                                                    )
                                                    .split("-")[1] *
                                                100
                                                : ""
                                            : ""}
                            {t("time-hour")}
                        </h5>
                    ) : (
                        <h5>
                            $
                            {Object.keys(JSON.parse(data.service_type))[0] == "tab1"
                                ? data.nanyperhrrate != null
                                    ? data.nanyperhrrate
                                    : ""
                                : Object.keys(JSON.parse(data.service_type))[0] == "tab2"
                                    ? data.seterhrrate
                                        ? data.seterhrrate
                                        : ""
                                    : Object.keys(JSON.parse(data.service_type))[0] == "tab3"
                                        ? data.seperhrrate
                                            ? data.seperhrrate
                                            : ""
                                        : Object.keys(JSON.parse(data.service_type))[0] == "tab4"
                                            ? data.tutorperhrrate
                                                ? data.tutorperhrrate
                                                : ""
                                            : ""}
                            {t("time-hour")}
                        </h5>
                    )}
          </div>

            {data.service_type != null &&
            Object.values(JSON.parse(data.service_type))[1] ? (
            <>
              <div className="post">
                  {data.service_type != null ? (
                      Object.values(JSON.parse(data.service_type))[1] == "Nanny" ? (
                          <img
                              src={
                                  window.location.origin +
                                  "/images/nany_post.svg"
                              }
                              alt=""
                          />
                      ) : Object.keys(JSON.parse(data.service_type))[1] ==
                      "tab2" ? (
                          <img
                              src={
                                  window.location.origin +
                                  "/images/teacher_post.svg"
                              }
                              alt=""
                          />
                      ) : Object.keys(JSON.parse(data.service_type))[1] ==
                      "tab3" ? (
                          <img
                              src={
                                  window.location.origin +
                                  "/images/education_post.svg"
                              }
                              alt=""
                          />
                      ) : Object.keys(JSON.parse(data.service_type))[1] ==
                      "tab4" ? (
                          <img
                              src={
                                  window.location.origin +
                                  "/images/tutor_post.svg"
                              }
                              alt=""
                          />
                      ) : (
                          ""
                      )
                  ) : (
                      ""
                  )}
                  <h5>

                      {data.service_type != null
                          ? t(Object.values(JSON.parse(data.service_type))[1])
                          : ""}
                  </h5>
              </div>

              <div className="post">
                <img
                  src={window.location.origin + "/img/post_pay.png"}
                  alt=""
                />
                  {language === 'sr' ? (
                      <h5>
                          {Object.keys(JSON.parse(data.service_type))[1] == "tab1"
                              ? data.nanyperhrrate != null
                                  ? data.nanyperhrrate
                                      .substr(
                                          data.nanyperhrrate.lastIndexOf("\\") +
                                          1
                                      )
                                      .split("-")[0] *
                                  100 +
                                  " - " +
                                  data.nanyperhrrate
                                      .substr(
                                          data.nanyperhrrate.lastIndexOf("\\") +
                                          1
                                      )
                                      .split("-")[1] *
                                  100
                                  : ""
                              : Object.keys(JSON.parse(data.service_type))[1] == "tab2"
                                  ? data.seterhrrate != null
                                      ? data.seterhrrate
                                          .substr(
                                              data.seterhrrate.lastIndexOf("\\") + 1
                                          )
                                          .split("-")[0] *
                                      100 +
                                      " - " +
                                      data.seterhrrate
                                          .substr(
                                              data.seterhrrate.lastIndexOf("\\") + 1
                                          )
                                          .split("-")[1] *
                                      100
                                      : ""
                                  : Object.keys(JSON.parse(data.service_type))[1] == "tab3"
                                      ? data.seperhrrate != null
                                          ? data.seperhrrate
                                              .substr(
                                                  data.seperhrrate.lastIndexOf("\\") + 1
                                              )
                                              .split("-")[0] *
                                          100 +
                                          " - " +
                                          data.seperhrrate
                                              .substr(
                                                  data.seperhrrate.lastIndexOf("\\") + 1
                                              )
                                              .split("-")[1] *
                                          100
                                          : ""
                                      : Object.keys(JSON.parse(data.service_type))[1] == "tab4"
                                          ? data.tutorperhrrate != null
                                              ? data.tutorperhrrate
                                                  .substr(
                                                      data.tutorperhrrate.lastIndexOf(
                                                          "\\"
                                                      ) + 1
                                                  )
                                                  .split("-")[0] *
                                              100 +
                                              " - " +
                                              data.tutorperhrrate
                                                  .substr(
                                                      data.tutorperhrrate.lastIndexOf(
                                                          "\\"
                                                      ) + 1
                                                  )
                                                  .split("-")[1] *
                                              100
                                              : ""
                                          : ""}
                          {t("time-hour")}
                      </h5>
                  ) : (
                      <h5>
                          $
                          {Object.keys(JSON.parse(data.service_type))[1] == "tab1"
                              ? data.nanyperhrrate != null
                                  ? data.nanyperhrrate
                                  : ""
                              : Object.keys(JSON.parse(data.service_type))[1] == "tab2"
                                  ? data.seterhrrate
                                      ? data.seterhrrate
                                      : ""
                                  : Object.keys(JSON.parse(data.service_type))[1] == "tab3"
                                      ? data.seperhrrate
                                          ? data.seperhrrate
                                          : ""
                                      : Object.keys(JSON.parse(data.service_type))[1] == "tab4"
                                          ? data.tutorperhrrate
                                              ? data.tutorperhrrate
                                              : ""
                                          : ""}
                          {t("time-hour")}
                      </h5>
                  )}
              </div>
            </>
          ) : (
            ""
          )}
          <div className="post">
            <img src={window.location.origin + "/images/post_fet.svg"} alt="" />
            <h5>
                {data.nanyintrestedin != null
                    ? (() => {
                        const nanyIntrestedin = parseIfJson(data.nanyintrestedin);

                        return getTranslatedInterest(nanyIntrestedin);
                    })()
                    : t("full-time")}
            </h5>
          </div>
          <div className="post">
            <img src="img/post_cal.png" alt="" />
            <h5>{data.nanystartdate != null
                ? data.nanystartdate
                : data.tutorstartdate}</h5>
          </div>
          <div className="post">
            <img src="img/post_loc.png" alt="" />
            <h5>
              {data.country != null ? data.country : ""} ,
              {data.city != null ? data.city : ""}
            </h5>
          </div>
        </div>
      </div>
      <p id={"show" + index}>
        {data.about != null ? data.about.substr(0, 100) : ""}
        {data.about != null && data.about.length > 100 ? (
          <span
            onClick={(e) =>
              handleElementContent(
                "show" + index,
                "hide" + index,
                "plink" + index
              )
            }
          >
            {t("text-more")}
          </span>
        ) : (
          ""
        )}
      </p>
      <p id={"hide" + index} className="hide">
        {data.about}
        <span
          onClick={(e) =>
            handleElementContent(
              "hide" + index,
              "show" + index,
              "plink" + index
            )
          }
        >
          {t("text-less")}
        </span>
      </p>

      <div className="view_profile_btn">
        <button
          onClick={(e) => {
            navigate("/profile-provider/" + data.id);
          }}
        >
          {t("view-profile")}
        </button>
      </div>
    </div>
  );
};
